// import $ from 'jQuery';
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);

global._isSP = false;
if(window.innerWidth < 768){
  _isSP = true;
}

const Init = function() {
  const _root = document.querySelector(':root');
  const $body = $("body");
  
  var kvSlider = new Swiper('.kv-slider', {
    loop: true,
    loopAdditionalSlides: 1,
    
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    }
  })
  
  $(".anchor").on("click", function () {
    const _$this = $(this);
    const _href = _$this.attr("href");
    const _tag = _href.replace(/#/, "");
    const _$target = $(_href);
    
    const _headerHeight = _root.style.getPropertyValue("--headerHeight");
    
    $("html, body").stop().animate({scrollTop: _$target.offset().top - _headerHeight}, 500);
    return false;
  });
  
  //var Resize = function (){};
  //$window.on('resize', Resize);
  //Resize();
  
  $body.addClass("loaded");
};

// Common Template の jQuery を読み込めた後に Init を発火させる
const ReadJS = function() {
  let __i__ = setInterval(function () {
    if (global.jQueryD !== void 0) {
      clearInterval(__i__);
      global.$ = global.jQueryD;
      Init();
    }
  }, 100);
};

window.addEventListener("load", ReadJS);


// YOUTUBE
const YoutubeFunc = function() {
  const tag = document.createElement('script');
  
  tag.src = "https://www.youtube.com/iframe_api";
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  
  let player = null;
  const ytData = "m-_imOGpKLE";
  const youtubeContainer = document.getElementById("bg_movie_container");
  const youtubeWrap = document.getElementById("bg_movie_wrap");
  
  global.onYouTubeIframeAPIReady = function () {
    player = new YT.Player("bg_movie", {
      height: '360',
      width: '640',
      videoId: ytData,
      playerVars: {
        'muted': 1,
        'controls': 0
      },
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      }
    });
  };
  
  global.onPlayerReady = function (event) {
    event.target.setVolume(0);
    event.target.mute();
    
    Resized();
    window.addEventListener("resize", Resized);
  };
  
  global.Resized = function (event) {
    if (window.innerWidth < 768) {
      _isSP = true;
      if (player.getPlayerState === 1) {
        player.pauseVideo();
      }
    } else {
      _isSP = false;
      if (player.getPlayerState !== 1) {
        player.playVideo();
      }
      
      const _w = youtubeContainer.clientWidth;
      const _h = youtubeContainer.clientHeight;
      const _ratio = _h / _w;
      
      if (_ratio < 0.5625) {
        youtubeWrap.classList.remove("_h");
        youtubeWrap.style.width = "";
        youtubeWrap.style.height = "";
      } else {
        youtubeWrap.classList.add("_h");
        let _cw = _w * 1.78;
        let _ch = _cw * 0.5625;
        youtubeWrap.style.width = _cw + "px";
        youtubeWrap.style.height = _ch + "px";
      }
    }
  };
  
  /*
  * YT.PlayerState.PAUSED
  * YT.PlayerState.ENDED
  * YT.PlayerState.PLAYING
  * */
  
  global.onPlayerStateChange = function (event) {
    const _this = event.target;
    if (event.data === YT.PlayerState.ENDED) {
      // end
      _this.seekTo(0);
      _this.playVideo();
    } else if (event.data === YT.PlayerState.PAUSED) {
      // pause
    } else if (event.data === YT.PlayerState.PLAYING) {
      // playing
    }
  }
};

//YoutubeFunc();